
// const LatestNew = () => import('~/components/Finance/LatestNew.vue');
export default {
  layout: 'empty',
  // components: { LatestNew },
  props: {
    error: {
      type: Object,
      default: () => ({
        statusCode: 500,
        message: '',
      }),
    },
  },

  data() {
    return {};
  },

  computed: {
    displayMessage() {
      if (this.error.statusCode == 404) {
        return 'We are comming soon';
      }
      return this.error.message;
    },
  },
};
